import ProductDeliveryOptions from "@/app/shared/ecommerce/product/product-delivery-options";
import ProductDetailsDescription from "@/app/shared/ecommerce/product/product-details-description";
import ProductDetailsGallery from "@/app/shared/ecommerce/product/product-details-gallery";
import ProductDetailsRelatedProducts from "@/app/shared/ecommerce/product/product-details-related-products";
import ProductDetailsReview from "@/app/shared/ecommerce/product/product-details-review";
import ProductDetailsSummery from "@/app/shared/ecommerce/product/product-details-summery";
import { modernProductsGrid } from "@/data/shop-products";
import { generateSlug } from "@/utils/generate-slug";
import { useParams } from "react-router-dom";

export default function ProductDetails() {
    const { id } = useParams();

    const product =
        modernProductsGrid.find((item) => generateSlug(item.title) === id) ??
        modernProductsGrid[0];

    return (
        <div className="@container">
            <div className="@3xl:grid @3xl:grid-cols-12">
                <div className="col-span-7 mb-7 @container @lg:mb-10 @3xl:pe-10">
                    <ProductDetailsGallery />
                </div>
                <div className="col-span-5 @container">
                    <ProductDetailsSummery product={product} />
                    <ProductDeliveryOptions />
                    <ProductDetailsDescription />
                    <ProductDetailsReview />
                </div>
            </div>
            <ProductDetailsRelatedProducts />
        </div>
    );
}
